<script setup lang="ts">
import { ref } from 'vue';
import BaseDialog from './base/BaseDialog.vue';
import TimelineItem from './TimelineItem.vue';
import { DTOTimelineStep } from '@/store/timelineStep.interface';
import { Locales } from '@/store/language.interface';

// CONST
const timelineitemDialogRef = ref<InstanceType<typeof BaseDialog>>();

// PROPS
const props = defineProps<{
  item?: DTOTimelineStep;
  languageEnabled?: Locales[];
}>();

// FUNCTIONS
function openDialog() {
  timelineitemDialogRef.value?.openDialog();
}

function closeDialog() {
  timelineitemDialogRef.value?.closeDialog();
}

defineExpose({
  openDialog,
  closeDialog,
});
</script>
<template>
  <BaseDialog ref="timelineitemDialogRef" @close="closeDialog()" :have-close-button="false">
    <template v-slot:content>
      <timeline-item v-if="props.item" :item="props.item" :language-enabled="props.languageEnabled" is-modal />
    </template>
  </BaseDialog>
</template>
<style lang="scss">
.q-dialog {
  .timeline-item {
    width: 100%;
  }
}
</style>
